// extracted by css-extract-rspack-plugin
export default {"Box":"TimelineDivider-module__Box__WVLUW","Box_1":"TimelineDivider-module__Box_1__I5kSG","Box_2":"TimelineDivider-module__Box_2__waaIl"};